import { Translation } from "react-i18next";
import buildingIcon from '../../images/building_office_icon_RGB.svg';
import './welcome-baner.scss';

type Props = {
    companyName: string | undefined
}

function WelcomeBaner(props:Props) {
    return (
        <div className='my-company-welcome-baner'>
            <img src={buildingIcon} alt="" />
            <div className='text-area'>
                <span><Translation>{t => t(`You are on {{companyName}} settings page.`, { companyName: props.companyName, 'interpolation': { 'escapeValue': false } })}</Translation></span><br />
                <span><Translation>{t => t("In order to get back to My Account use Back button in the top left corner.")}</Translation></span>
            </div>   
        </div>
    )

}

export default WelcomeBaner;